import { React, Component, useState, useRef } from "react";
import ReactDOM from "react-dom/client";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Navi from "./nav";
import Footy from "./footer";
import ProgressBar from "./progressBar";

import Button from "react-bootstrap/Button";
import ListGroup from "react-bootstrap/ListGroup";
import ListGroupItem from "react-bootstrap/esm/ListGroupItem";
import Toast from "react-bootstrap/Toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
// import { Modal } from "react-bootstrap";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import axios from "axios";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";

axios.defaults.withCredentials = true;

const PowerTranzHost = process.env.REACT_APP_POWERTRANZ_HOST;

const crm = axios.create({
  baseURL: process.env.REACT_APP_API_URL + "/crmcom",
  headers: {
    api_key: process.env.REACT_APP_API_KEY,
  },
});

function Payment() {
  const modalRef = useRef();

  const [orderId, setOrderId] = useState("");
  const [messageHeader, setMessageHeader] = useState("");
  const [messgeBody, setMessageBody] = useState("");
  const [rrn, setRRN] = useState("");
  const [orderTotal, setOrderTotal] = useState("");
  const [orderDate, setOrderDate] = useState("");
  const [orderName, setOrderName] = useState("");
  const [orderProduct, setOrderProduct] = useState("");
  const [orderCard, setOrderCard] = useState("");
  const [theCompany, setCompanyName] = useState("");
  const [orderStatus, setOrderStatus] = useState(0);
  const [orderAmount, setOrderAmount] = useState(0);
  const [orderAuthCode, setOrderAuthCode] = useState("");
  const [displayDetails, setDisplayDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmationResponse, setConfirmationResponse] = useState("");
  const [showItems, setShowItems] = useState(false);
  const [paymentWasSuccessful, setPaymentWasSuccessful] = useState(false);
  const [confirmationResponseBackground, setConfirmationResponseBackground] =
    useState("alert alert-light");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();

  const activeStep = 3;

  useEffect(() => {
    // const url = "https://localhost:4001/fac/payment"; // replace with your url
    const payment_url = process.env.REACT_APP_FAC_URL + "/payment"; // replace with your url
    const body = {}; // replace with your request body
    const headers = {}; // replace with your headers
    setLoading(true);

    axios
      .post(payment_url, body, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log(response);
        if (response.status == 200) {
          setOrderProduct(JSON.parse(localStorage.getItem("product")).name);
          localStorage.removeItem("product");
          // setMessageHeader("Payment Successful!");
          // setMessageBody("Thank you for your order. ");
          setOrderId(response.data.id);
          let payment_method = JSON.parse(
            localStorage.getItem("payment_method")
          );
          setOrderName(payment_method.card.name);
          setOrderCard(
            payment_method.card.brand +
              " " +
              payment_method.card.first6 +
              "######" +
              payment_method.card.last4
          );
          crm
            .get(
              "/contacts/" +
                localStorage.getItem("contact_id") +
                "/orders/" +
                response.data.id
            )
            .then((order_response) => {
              try {
                console.log("TRANSCEND inside refresh try block");
                crm
                  .get("/refresh")
                  .then((res) => {
                    console.log("TRANSCEND user refresh response: ", res.data);
                    let current_active_product = JSON.parse(
                      localStorage.getItem("active_product")
                    );
                    current_active_product.active_services =
                      res.data.active_plans.active_services;
                    localStorage.setItem(
                      "active_product",
                      JSON.stringify(current_active_product)
                    );
                    localStorage.setItem(
                      "service_status",
                      JSON.stringify(res.data.service_status)
                    );
                  })
                  .catch((err) => {
                    console.log("TRANSCEND user refresh err: ", err);
                  });
              } catch (error) {}
              console.log("Order Reesponse: ", order_response);

              let order_date = new Date(
                order_response.data.key_dates.completed_on * 1000
              );
              setOrderDate(order_date.toString());
              setCompanyName(order_response?.data?.fulfilled_by?.name || "SWITCHTT");
              // console.log('Order Amount: ' + order_response.data.items[0].product.price);
              setOrderAmount(
                order_response.data.items[0].product.price +
                  " " +
                  order_response.data.currency_code
              );
              setOrderAuthCode(order_response.data.authCode);
              console.log("TRANSCEND Authorization Code: " + order_response);
              // console.log('---- TRANSCEND Order endpoint result end -------------------------------');
              handleShow();
              setLoading(false);
              setPaymentWasSuccessful(true);
            })
            .catch((error) => {
              console.error(`Error: ${error}`);
              setPaymentWasSuccessful(false);
              setLoading(false);
            });
        } else {
          // navigate("/");
          console.log(response);
          setLoading(false);
        }
      })
      .catch((error) => {
        // console.error(`Error: ${error}`);
        if (!axios.isAxiosError(error) || error.response.status !== 404) {
          console.error(`Error: ${error}`);
        }
        setLoading(false);
        setPaymentWasSuccessful(false);
        // navigate("/");
      });
  }, []);

  useEffect(() => {
    // console.log(`setting order status ${orderStatus}`);
    if (orderStatus == 200) {
      setDisplayDetails(true);
    }
  }, [orderStatus]);

  const handlePrint = () => {
    // Print the specific content of the modal
    try {
      handleShow();
      const printContent = modalRef.current;
      console.log;
      const printWindow = window.open("", "_blank");
      printWindow.document.write(
        "<html><head><title>Print</title></head><body>"
      );
      printWindow.document.write(printContent.innerHTML);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.print();
    } catch (error) {
      console.log(`Error: ${error}`);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        theme="dark"
      />

      <Navi />
      <div>
        <ProgressBar activeStep={activeStep} />
      </div>
      {/* use a toast instead  */}
      <div className="iki-form-desc text-center">
        <div
          className={confirmationResponseBackground + "p-0 m-0 pe-0 ps-0"}
          role="alert"
        >
          {/* {confirmationResponse} */}
        </div>
      </div>
      {/* use a toast instead  */}

      <div className="fs-2 fw-bold col-lg-6 col-sm-12 col-md-12 text-secondary text-center">Payment</div>
      <div className="page-estimate   mt-4 col-lg-6 col-sm-12 col-md-12">
        {/* <h2>{messageHeader}</h2> */}

        {orderId != "" && paymentWasSuccessful && (
          <>
            <h4 className="mt3 text-center">SUCCESS</h4>
            <p className="mt-2 text-center">Thank you for your order!</p>
            <div className="text-center mt-4 sw-r-p">
              <a href="/">
                <i className="mdi mdi-home" /> Dashboard
              </a>{" "}
              <a href="#" onClick={handleShow}>
                <i className="mdi mdi-printer" /> Show receipt
              </a>
            </div>
            {/* <Button variant="link" href="/">
              <i className="mdi mdi-home" /> Dashboard
            </Button> */}
          </>
        )}

        {loading ? (
          <>
            <div className="text-center mt-1 mb-2">
              ...processing, please wait.
            </div>
            <div className="text-center row">
              <div className="col">
                <div
                  className="page-loading iki-spinner spinner-border"
                  role="status"
                >
                  <span className="sr-only"></span>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* <Button variant="link" onClick={handlePrint}>
              Print receipt
            </Button> */}

            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div ref={modalRef} className="print-receipt">
                  <div className="text-center">
                    <img
                      style={{ maxWidth: "150px" }}
                      src="data:image/png;base64,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"
                      alt="logo"
                    />
                  </div>
                  <br />

                  <h5 className="fw-bold text-center mb-2">RECEIPT</h5>

                  <ListGroup className="fs-6 sw-receipt">
                    <ListGroup.Item>
                      <div className="d-flex">
                        <div className="col-4 text-left">Order #</div>
                        <div className="col-8 text-right fw-bold">{orderId}</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="d-flex">
                        <div className="col-4 text-left">Company</div>
                        <div className="col-8 text-right">
                          <div>{theCompany}</div>
                          <a href="http://switchtt.com">https://switchtt.com</a>
                        </div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="d-flex">
                        <div className="col-4 text-left">Date</div>
                        <div className="col-8 text-right">{orderDate}</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="d-flex">
                        <div className="col-4 text-left">Product</div>
                        <div className="col-8 text-right">{orderProduct}</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="d-flex">
                        <div className="col-4 text-left">Amount</div>
                        <div className="col-8 text-right">${orderAmount}</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="d-flex">
                        <div className="col-4 text-left">Name</div>
                        <div className="col-8 text-right">{orderName}</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="d-flex">
                        <div className="col-4 text-left">Card</div>
                        <div className="col-8 text-right">{orderCard}</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="d-flex">
                        <div className="col-4 text-left">
                          Authorisation Code
                        </div>
                        <div className="col-8 text-right">{orderAuthCode}</div>
                      </div>
                    </ListGroup.Item>
                  </ListGroup>
                  <p className="mt-3 text-center">
                    Please <strong>print</strong> or{" "}
                    <strong>
                      save a digital <br />
                      copy
                    </strong>{" "}
                    of this receipt for your records.
                  </p>
                </div>
                <div classname="text-center">
                  {/* <Button className="btn btn-link" onClick={handlePrint}>
                    <i className="mdi mdi-printer" /> Print Receipt
                  </Button> */}
                  <div className="row">
                    <div className="col-4"></div>
                    <div className="col-4">
                      <Button style={{width:"100%", margin:"0 auto"}}variant="link" onClick={() => window.print()}>
                        <i className="mdi mdi-printer" /> Print receipt
                      </Button>
                    </div>
                    <div className="col-4"></div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </>
        )}
      </div>
    </>
  );
}

export default Payment;
